<template>
	<div class="franchaise_mob_accordian">
		<img class="w-100" style="margin: 10px 0 30px" :src="img.image2" alt="" />
		<div class="accordion" id="accordionExample">
			<div class="accordion-item">
				<h2 class="accordion-header" id="headingOne">
					<button
						class="accordion-button"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#franchaiseOne"
						aria-expanded="true"
						aria-controls="franchaiseOne"
					>
						<h4>JPWorldPay Merchant Terms & Conditions (For Online Payment)</h4>
						<i class="fa-solid fa-chevron-down ms-auto"></i>
					</button>
				</h2>
				<div
					id="franchaiseOne"
					class="accordion-collapse collapse show"
					aria-labelledby="headingOne"
					data-bs-parent="#accordionExample"
				>
					<div class="accordion-body">
						The JPWorldPay Merchant Terms and conditions (hereinafter referred
						to as "These terms and conditions" including annexed special
						agreements, terms of use, guidelines, etc.) applies to the use and
						applications for use of JPWorldPay, a payment service specified in
						Article 2, provided by JPWorldPay Co., Ltd. (hereinafter referred to
						as "the Company").
					</div>
				</div>
			</div>
			<div class="accordion-item">
				<h2 class="accordion-header" id="headingTwo">
					<button
						class="accordion-button collapsed"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#franchaiseTwo"
						aria-expanded="false"
						aria-controls="franchaiseTwo"
					>
						<h4>Article 1: Definitions Of Terms</h4>
						<i class="fa-solid fa-chevron-down ms-auto"></i>
					</button>
				</h2>
				<div
					id="franchaiseTwo"
					class="accordion-collapse collapse"
					aria-labelledby="headingTwo"
					data-bs-parent="#accordionExample"
				>
					<div class="accordion-body">
						<p>
							The definitions of terms in these Terms and Conditions are as
							follows:
						</p>
						<p>
							"Merchant" refers to a person who has approved these Terms and
							Conditions and has applied for the use of JPWorldPay and the
							Company has accepted it.
						</p>
						<p>
							"Card" refers to a card (including other objects or numbers,
							symbols and other symbols) that can be presented or notified and
							then can purchase or receive goods, etc.
						</p>
						<p>
							"Card Company" refers to the general terms of person designated by
							the Company among corporations, organizations and other
							organizations that issue or grant cards or operate credit card
							services.
						</p>
						<p>
							"Other Payment Methods" refers to payment methods other than the
							JPWorldPay balance or card that can be used in JPWorldPay, the
							payment service stipulated in Article 2.
						</p>
						<p>
							"JPWorldPay user" refers to a person who has agreed to the
							Company's prescribed terms and conditions and has been authorized
							by the Company to make payments using JPWorldPay balance and card.
						</p>
						<p>
							"Card-Related Information" refers to information necessary to use
							the card, such as the JPWorldPay user's card number, card
							expiration date, card security code, or the JPWorldPay user's name
							and phone number registered with the card company.
						</p>
						<p>
							"Products, etc." refers to goods or rights sold by merchants or
							services provided.
						</p>
						<p>
							"Payment-Related information" refers to amount, number, and
							payment history paid through JPWorldPay, and payment related
							information, such as codes, etc. that the Company provides to
							merchants on behalf of card-related information.
						</p>
						<p>
							"Order-Related Information" refers to the amount of products, etc.
							paid by JPWorldPay, and other information related to other
							orders..
						</p>
						<p>
							"Payment for Products, etc." refers to the sale price of products
							or the price for providing them, including taxes, shipping
							charges, and other charges recognized by the the Company.
						</p>
						<p>
							"Points" refers to points awarded by the Points Program designated
							by the Company.
						</p>
						<p>
							"Coupon" refers to a coupon that can be used to pay all or part of
							the price for products, etc. issued to JPWorldPay users by the
							Company or a third party designated by the Company.
						</p>
						<p>
							"JPWorldPay Balance" refers to the generic terms of JPWorldPay
							Money, JPWorldPay Money Lite, JPWorldPay Points, and JPWorldPay
							Bonus Lite issued by the the Company in accordance with the
							JPWorldPay Balance Terms of Use.
						</p>
						<p>
							"JPWorldPay balance transaction" refers to a transaction in which
							the payment is made by using the JPWorldPay balance in lieu of
							repayment by money in case of JPWorldPay users purchasing
							products, etc. from merchants.
						</p>
					</div>
				</div>
			</div>
			<div class="accordion-item">
				<h2 class="accordion-header" id="franchaiseThree">
					<button
						class="accordion-button collapsed"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#franchaiseThree"
						aria-expanded="false"
						aria-controls="franchaiseThree"
					>
						<h4>Article 2: JPWorldPay</h4>
						<i class="fa-solid fa-chevron-down ms-auto"></i>
					</button>
				</h2>
				<div
					id="franchaiseThree"
					class="accordion-collapse collapse"
					aria-labelledby="headingThree"
					data-bs-parent="#accordionExample"
				>
					<div class="accordion-body">
						<p>
							The Company, in relation to merchants, in the sales transaction of
							products, etc. with JPWorldPay users, provides to the merchant a
							service (hereinafter collectively referred to as "Pay") selected
							by the merchant at the time of application under paragraph 1 of
							the following Article to realize ① payment for products, etc. by
							the JPWorldPay balance, ② payment for products, etc. by card
							(Completion of card-related information without the merchants
							itself obtaining or holding) or ③ payment of products, etc. by
							other means of payment. But, regarding the functions prescribed in
							subparagraph 5, the Company separately otifys the merchant of the
							timing and details of the provision.
						</p>
						<ul>
							<li>Payment of products, etc. in arrears or receipt by proxy</li>
							<li>
								An act in lieu of business performed by the merchant, such as a
								request from a credit card company for the payment of products,
								etc.
							</li>
							<li>Manage card-related information</li>
							<li>
								Provision of a computer program (hereinafter referred to as
								"JPWorldPay for Business") that has the function of managing
								orders, such as reading order-related information, receiving or
								canceling orders from JPWorldPay users
							</li>
							<li>
								Provision of what the Company adds as a function that
								contributes to attracting customers of merchants
							</li>
							<li>
								Provision of a barcode display function that records information
								such as product prices, etc. displayed for JPWorldPay users in
								order to enable sales approval processing in accordance with
								Articles 11 through 11-5
							</li>
							<li>
								Provision of the ability for merchants to send payment
								notifications to JPWorldPay users
							</li>
							<li>
								Provision of the function (hereinafter referred to as
								"Provisional payment function". Merchants can choose whether to
								use the provisional payment function for each product they sell,
								etc.) for holding the JPWorldPay balance equivalent to the
								product in JPWorldPay's users wallet (refers to the service that
								allows you to register and manage payment methods provided by
								the Company. The same applies hereinafter) then leaving the
								balance unavailable for other transactions, and completing the
								payment based on the balance at the time of payment for the
								product, etc. determined by the contract between the merchant
								and the JPWorldPay user, when a JPWorldPay user chooses to pay
								by JPWorldPay balance in applying for purchase of products, etc.
							</li>
							<li>
								Provision of the function (hereinafter referred to as "Payment
								reservation function". Merchants can choose whether to use the
								payment reservation function for each product they sell, etc.)
								for performing a request for payment approval in advance to the
								credit card company or a request for payment approval neccessary
								for a contract related to other payment methods, and making
								payment at the time of payment of payment, etc. when a
								JPWorldPay user chooses to pay by card or other payment method
								in applying for purchase of products, etc.
							</li>
							<li>
								Provision of the function (hereinafter referred to as
								"Continuous payment function") of allowing the merchants to
								perform the necessary procedures for payment of products, etc.
								by obtaining comprehensive consent from the JPWorldPay users in
								advance to make a payment using JPWorldPay for one or more
								transactions (hereinafter referred to as "Continuous
								transaction") including transaction on exchange between
								merchants and JPWorldPay users without going through the
								application by JPWorldPay users at the individual payment period
								set in the continuous transaction.
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="accordion-item">
				<h2 class="accordion-header" id="franchaiseFour">
					<button
						class="accordion-button collapsed"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#franchaiseFour"
						aria-expanded="false"
						aria-controls="franchaiseFour"
					>
						<h4>Article 3: Establishment Of A Contract</h4>
						<i class="fa-solid fa-chevron-down ms-auto"></i>
					</button>
				</h2>
				<div
					id="franchaiseFour"
					class="accordion-collapse collapse"
					aria-labelledby="headingThree"
					data-bs-parent="#accordionExample"
				>
					<div class="accordion-body">
						<p>
							The person who applies for the use of JPWorldPay (hereinafter
							referred to as "This applicant") shall, after approving these
							Terms and Conditions and the privacy policy prescribed by the
							Company, apply for the use of JPWorldPay in the prescribed manner.
						</p>
						<p>
							In applying for the use of JPWorldPay, this applicant represents
							and warrants that the materials to be submitted to the Company or
							what is reported to the Company are accurate and up-to-date.
						</p>
						<p>
							When the Company receives an application for use of JPWorldPay,
							the Company will conduct an examination of the applicant
							(hereinafter referred to as "Examination of the case").
							Examination of the case includes examination by a credit card
							company and examination by a third party necessary to use each
							payment method in JPWorldPay (hereinafter, the company, the credit
							card company, and such third parties are collectively referred to
							as "Companies"). This applicant shall accept that depending on
							result of the examination of the case, it may not be possible to
							receive payment for products such as products by card.
						</p>
						<p>
							As a result of this examination, at the time when the Company
							accepts the application for use of JPWorldPay, with this applicant
							as a merchant, / Payment service use contract based on these terms
							and conditions (hereinafter referred to as the "Contract") and the
							contract based on the JPWorldPay Balance Merchant Agreement (for
							online payment) established by the Company are concluded. In
							addition to the provisions of these Terms and Conditions, the
							merchant must comply with the JPWorldPay Balance Merchant Terms
							and Conditions for payment by JPWorldPay balance in JPWorldPay
							according to each of the following subparagraph. In addition, if
							there are any other provisions that contradict or conflict with
							these Terms and Conditions in the JPWorldPay Balance Merchant
							Agreement, the provisions of these Terms and Conditions take
							precedence and for matters not stipulated in these Terms and
							Conditions, the JPWorldPay Balance Merchant Agreement shall apply
							to payment by JPWorldPay Balance.
						</p>
						<p>
							This applicant shall be deemed to have submitted the application
							for Article 3 and Article 4 of the JPWorldPay Balance Merchant
							Agreement by applying for use in accordance with Paragraph 1 of
							this Article.
						</p>
						<p>
							When a JPWorldPay user chooses to pay by JPWorldPay balance in the
							method prescribed by the Company as stipulated in Article 5,
							Paragraph 2 of the JPWorldPay Balance Merchant Terms and
							Conditions, if the sales confirmation processing stipulated in
							Article 11 paragraph 2 or Article 11-2 paragraph 4 including the
							case where Article 11-2 paragraph 4 is applied based on Article
							11-5 Paragraph 2 is completed, in accordance with Article 5
							paragraph 2 of the Pay Balance Merchant Terms and Conditions, the
							Company will reduce the Pay balance and follow the provisions of
							the same Article.
						</p>
						<p>
							If there is a need to cancel the transaction prescribed in Article
							8 Paragraph 2 of the JPWorldPay Balance Merchant Agreement, it
							shall be carried out in accordance with Article 16 of this terms
							and conditions.
						</p>
						<p>
							Payment of the prescribed payment system usage fee, etc. in
							JPWorldPay Balance Merchant Agreement Article 11 and the
							settlement prescribed in Article 12 shall be carried out in
							accordance with Articles 13 and 14 of these terms and conditions.
						</p>
						<p>
							When the payment due to the JPWorldPay balance falls under any of
							the subparagraphs of Article 19 paragraph 1 of the JPWorldPay
							Balance Merchant Agreement, it is regarded as falling under each
							subparagraph of Article 18 Paragraph 1 of these terms and
							conditions and handled in accordance with the provisions of
							paragraphs 2 through 6 of the same Article.
						</p>
						<p>
							When, as a result of this examination, the credit card company
							approved the application for the payment of the payment for
							products, etc. by card, between this applicant and the credit card
							company specified in each of the following subparagraphs, a card
							merchant contract based on the card merchant agreements
							(hereinafter referred to as "card merchant agreement") as
							stipulated in each of the following paragraphs depending on the
							credit card company is concluded.
						</p>
						<p>
							Card Company: The CompanyCard Merchant Agreement: The Postpaid
							Payment Merchant Terms and Conditions (for online payment)
						</p>
						<p>
							Card company: Card company notified separately by JPWorldPayCard
							Merchant Agreement: Card Merchant Agreement notified separately by
							the Company
						</p>
						<p>
							The Company does not disclose the progress of examination of the
							case, the reasons for the results, etc.
						</p>
						<p>
							Merchant agrees in advance that information about merchants may be
							posted on the Company, website of a third party designated by the
							Company, and promotional materials, etc. and that the publication
							may be discontinued at the discretion of the Company, or a third
							party designated by the Company. Do the same for information about
							additional or changed merchants in accordance with the following
							paragraphs.
						</p>
						<p>
							In case of additions or changes to the merchant information
							reported pursuant to paragraph 2, the merchant shall report it in
							advance by the Company's prescribed method.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import franchaise from '@/assets/images/sub/franchaise_ban.png';
import line_arow from '@/assets/images/sub/line_arow.png';

// components
export default {
	name: 'AgreementMobile',
	data() {
		return {
			img: {
				image1: franchaise,
				image2: line_arow,
			},
		};
	},
};
</script>
